<template>
  <div class="wrapper">
    <slot name="background" :step="step"> Background </slot>

    <!-- poi-info -->
    <!-- poi-info -->
    <!-- poi-info -->
    <div
      v-if="showCard"
      class="route-container d-flex flex-column"
      :class="
        step == 3 && !$vuetify.breakpoint.xs
          ? 'route-container web'
          : ''
          ? step == 3
          : 'route-container'
      "
      :style="routeContainerStyle"
      v-hammer:pan.vertical="(event) => onPan(event)"
    >
      <!-- bg -->

      <v-img
        :class="backgroundImageStyle"
        :src="cardImage"
        :style="step == 3 ? main : ''"
      >
        <!-- title container  -->
        <slot name="title" :step="step"> </slot>
        <!-- title -->

        <!-- top controllers -->
        <v-divider
          v-if="step != 3"
          width="50px"
          class="white"
          style="
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%);
            margin-top: 15px;
            padding-bottom: 1px;
          "
        >
        </v-divider>
        <transition name="fade">
          <button
            :style="buttontop"
            v-if="step == 3 && $vuetify.breakpoint.xs"
            @click="resetContainerStyle"
            style="
              height: 18px;
              width: 30px;
              position: absolute;
              top: 15px;
              right: 20px;
              transform: translate(-50%);
              z-index: 1;
              margin-top: 15px;
            "
          >
            <img src="@/assets/icons/Drop Down Button.svg" />
          </button>
        </transition>
        <!-- top controllers -->
      </v-img>

      <!-- bg -->

      <!-- content -->
      <slot name="content" :step="step"> </slot>
      <slot name="bottomNavigation" :step="step"> </slot>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  props: {
    showCard: Boolean,
    cardImg: String,
    cardColor: String,
    topDistance: String,
    titleContainerHeight: Boolean,
    bottomDistance: String,
  },

  mounted() {
    if (this.$vuetify.breakpoint.xs)
      this.routeContainerStyle = `top: calc(${this.topDistance})`;
    else {
      this.routeContainerStyle = `top: 0`;
      this.step = 3;
      this.setMenuIconColor("white");
    }
    console.log();
  },

  beforeDestroy() {
    this.resetContainerStyle();
  },

  data() {
    return {
      routeContainerStyle: null,
      step: 1,
      imageLoader: true,
    };
  },

  computed: {
    ...mapState({
      insets: (state) => state.base.insets,
      currentTour: (state) => state.routes.currentTour,
    }),

    main() {
      if (
        this.currentTour.multi_day &&
        this.$route.path.split("/")[1] == "route"
      ) {
        return `height: calc(${
          this.insets?.top ? this.insets?.top + "px" : "0px"
        } + 160px)`;
      } else {
        return `height: calc(${
          this.insets?.top ? this.insets?.top + "px" : "0px"
        } + 125px)`;
      }
    },

    buttontop() {
      return `top: calc(${
        this.insets?.top ? this.insets?.top + "px" : "0px"
      } + 15px)`;
    },

    backgroundImageStyle() {
      if (this.step == 3) {
        if (!this.$vuetify.breakpoint.xs)
          return `background-image shrinked web ${this.cardColor}`;
        if (this.titleContainerHeight)
          return `background-image shrinked custom-height ${this.cardColor}`;

        return `background-image shrinked ${this.cardColor}`;
      }
      if (this.step == 0) {
        return `background-image shrinked-bottom custom-height ${this.cardColor}`;
      }
      if (!this.cardImg) return `background-image card ${this.cardColor}`;
      return `background-image ${this.cardColor}`;
    },

    cardImage() {
      if (this.cardImg != null) {
        return this.cardImg;
      }
      return "";
    },
  },

  methods: {
    ...mapMutations(["setMenuIconColor"]),

    resetContainerStyle() {
      this.routeContainerStyle = `top: calc(${this.topDistance})`;

      this.step = 1;
      this.setMenuIconColor("blue");
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    onImageLoad() {
      this.imageLoader = false;
    },

    onPan(event) {
      if (this.step == 3) return;
      if (event.direction == 8) {
        // pun up

        if (event.isFinal && event.distance < 170) {
          if (this.step == 0) {
            // this.routeContainerStyle = `top: ${this.bottomDistance}`;
          }
          if (this.step == 1) {
            this.routeContainerStyle = `top: calc(${this.topDistance})`;
          } else if (this.step == 2) this.routeContainerStyle = "top: 30px";
        } else if (event.isFinal && event.distance > 170) {
          if (this.step == 0) {
            this.routeContainerStyle = `top: calc(${this.topDistance})`;
            this.step = 1;
            return;
          }
          if (this.step == 1) {
            this.routeContainerStyle = "top: 30px";
            this.step = 2;
            return;
            // console.log("step: 2");
          } else if (this.step == 2) {
            this.routeContainerStyle = "top: -56px";
            this.step = 3;
            this.setMenuIconColor("white");
            return;
          }
        } else if (!event.isFinal) {
          if (this.step == 1)
            this.routeContainerStyle = `top:calc(${this.topDistance} - 80px)`;
          else
            this.routeContainerStyle = `top:calc(30px - ${event.distance}px)`;
        }
      } else if (event.direction == 16) {
        //pun down
        if (event.isFinal && event.distance > 170) {
          if (this.step == 1) {
            this.step = 0;
            // this.routeContainerStyle = `top: calc(${this.bottomDistance})`;
          }
        }
      }
    },

    // onPanDown(event) {
    //   console.log("pan down", event);
    //   if (event.isFinal && event.distance < 170) {
    //     if (this.step == 1) this.routeContainerStyle = `top:calc(200px)`;
    //   }
    // },
  },
};
</script>

<style scoped>
.wrapper {
  position: relative;
}

.route-container {
  background: white;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  transition: all 0.6s ease;
  z-index: 2;
  width: 100vw;
  border-radius: 100px;
}
.route-container.web {
  width: 30vw;
  min-height: calc(100vh - 60px);
  height: auto;
  border-radius: 0;
  background: #ede5dd;
}

.route-container.shrinked {
  touch-action: pan-y !important;
}

.googleMap {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 0;
  height: 100vh;
}

.background-image {
  height: 353.53px;
  max-height: auto;
  transition: height 0.4s linear;
  /* overflow: visible; */
  border-top-left-radius: 35px;
  border-top-right-radius: 35px;
  width: 100vw;
}

.background-image.web {
  width: 30vw;
}

.background-image.card {
  height: 255.53px;
  border-top-left-radius: 35px;
  border-top-right-radius: 35px;
  overflow: visible;
}

.background-image.shrinked {
  height: 125px;
  position: fixed;
  top: 0;
  left: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  z-index: 99;
  overflow: visible;
}

.background-image.shrinked-bottom {
  height: 125px;
  position: fixed;
  bottom: 0;
  left: 0;
  /* border-top-left-radius: 0;
  border-top-right-radius: 0; */
  z-index: 99;
}

.background-image.shrinked.custom-height {
  height: 160px;
}
</style>
